import React from "react";
import styles from "../styles/uniform.module.css";

function Uniform(props) {
  const section = props.section;

  if (section === "squirrels") {
    return (
      <section className={styles.uniform}>
        <h2>Uniform</h2>
        <p>Squirrels wear a distinctive red sweatshirt, paired with our group neckerchief and woggle.</p>
        <p>
          Uniform can be purchased from the <a href="https://www.butcherscoppice.org.uk/">local Scout shop</a> or from the <a href="https://shop.scouts.org.uk/">online Scout store</a>.
        </p>
        <div className={styles.imageGrid}>
          <img src={`${process.env.PUBLIC_URL}/images/squirrels-uniform.jpg`} alt="Squirrels Uniform" />
          <img src={`${process.env.PUBLIC_URL}/images/squirrels-badge.jpg`} alt="Squirrels Badge Placement" />
        </div>
      </section>
    );
  } else if (section === "beavers") {
    return (
      <section className={styles.uniform}>
        <h2>Uniform</h2>
        <p>Beavers wear a smart blue jumper along with the group neckerchief and woggle.</p>
        <p>
          Uniform can be purchased from the <a href="https://www.butcherscoppice.org.uk/">local Scout shop</a> or from the <a href="https://shop.scouts.org.uk/">online Scout store</a>.
        </p>
        <div className={styles.imageGrid}>
          <img src={`${process.env.PUBLIC_URL}/images/beavers-uniform.jpg`} alt="Beavers Uniform" />
          <img src={`${process.env.PUBLIC_URL}/images/beavers-badge.jpg`} alt="Beavers Badge Placement" />
        </div>
      </section>
    );
  } else if (section === "cubs") {
    return (
      <section className={styles.uniform}>
        <h2>Uniform</h2>
        <p>Cubs wear a green sweatshirt, suitable activity trousers, sturdy shoes and the group neckerchief and woggle.</p>
        <p>
          Uniform can be purchased from the <a href="https://www.butcherscoppice.org.uk/">local Scout shop</a> or from the <a href="https://shop.scouts.org.uk/">online Scout store</a>.
        </p>
        <div className={styles.imageGrid}>
          <img src={`${process.env.PUBLIC_URL}/images/cubs-uniform.jpg`} alt="Cubs Uniform" />
          <img src={`${process.env.PUBLIC_URL}/images/cubs-badge.jpg`} alt="Cubs Badge Placement" />
        </div>
      </section>
    );
  } else if (section === "scouts") {
    return (
      <section className={styles.uniform}>
        <h2>Uniform</h2>
        <p>Scouts wear a khaki shirt, activity trousers, sturdy shoes and the group neckerchief and woggle.</p>
        <p>
          Uniform can be purchased from the <a href="https://www.butcherscoppice.org.uk/">local Scout shop</a> or from the <a href="https://shop.scouts.org.uk/">online Scout store</a>.
        </p>
        <div className={styles.imageGrid}>
          <img src={`${process.env.PUBLIC_URL}/images/scouts-uniform.jpg`} alt="Scouts Uniform" />
          <img src={`${process.env.PUBLIC_URL}/images/scouts-badge.jpg`} alt="Scouts Badge Placement" />
        </div>
      </section>
    );
  }

  return null; // in case no section matches
}

export default Uniform;
